<template>
  <!-- Start Service Area  -->
  <v-row class="service-main-wrapper">
    <!-- Start Single Service  -->
    <v-col
      lg="4"
      md="6"
      sm="6"
      cols="12"
      v-for="(service, i) in serviceContent"
      :key="i"
    >
      <div class="text-left service service__style--2">
        <!-- <router-link to="/service-details"> -->
          <div class="service">
            <div class="icon" v-html="iconSvg(service.icon)"></div>
            <div class="content">
              <h3 class="heading-title">{{ service.title }}</h3>
              <p>
                {{ service.desc }}
              </p>
            </div>
          </div>
        <!-- </router-link> -->
      </div>
    </v-col>
    <!-- End Single Service  -->
  </v-row>
  <!-- Start Service Area  -->
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        serviceContent: [
          {
            icon: "cpu",
            title: "Sistemas Sob Medida",
            desc: `Sistema feito para o seu negócio, com foco em performance.`,
          },
          {
            icon: "smartphone",
            title: "Aplicativos",
            desc: `Apps rápidos e estáveis para web e mobile, prontos para escalar.`,
          },
          {
            icon: "git-merge",
            title: "Integrações e APIs",
            desc: `Conectamos sistemas, balanças, PDV/POS e outros dispositivos.`,
          },
          {
            icon: "zap",
            title: "Automação de Processos",
            desc: `Menos tarefas manuais, mais velocidade e confiabilidade.`,
          },
          {
            icon: "bar-chart-2",
            title: "Dashboards e BI",
            desc: `Métricas claras e em tempo real para decisões melhores.`,
          },
          {
            icon: "refresh-cw",
            title: "Modernização de Sistemas",
            desc: `Melhoramos performance e adicionamos novas funções.`,
          },
        ],
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>
